// extracted by mini-css-extract-plugin
export var cancelButton = "_my-5";
export var content = "_my-3";
export var createButton = "_my-6";
export var drawerContainer = "_my-0";
export var footer = "_my-2";
export var header = "_my-1";
export var orderFormColumn = "_my-4";